import { CONFIG } from 'src/global-config';

import { Image } from 'src/components/image';

// ----------------------------------------------------------------------

export function PageNotFoundIllustration({ ref, sx, ...other }) {
  return (
    <Image
      alt="404 Illustration"
      src={`${CONFIG.assetsDir}/assets/illustrations/illustration-404.webp`}
      sx={[
        {
          width: 320,
          height: 'auto',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    />
  );
}
